import { Navigate, useParams, useSearchParams } from "react-router";
import useSWR from "swr";
import { simpleFetcher } from "~/api/fetcher";
import { CenterSpinner } from "~/atoms/spinner";
import NoResult from "~/molecules/NoResult";
import { getResolvedPublishedDocumentPath } from "./publishedDocumentResolver";

const publishedDocumentTargetEndpoint = "/api/v2/documents/get-id";

interface PublishedDocumentTarget {
  documentId: number;
  latestPublishedVersionId: number | null;
}

const PublishedDocumentResolverPage = () => {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const shouldOpenInWord = searchParams.get("open") === "word";

  const { data, isLoading } = useSWR<PublishedDocumentTarget>(
    projectId ? `${publishedDocumentTargetEndpoint}/${projectId}` : null,
    simpleFetcher,
  );

  if (isLoading) {
    return <CenterSpinner />;
  }

  if (!data) {
    return <NoResult />;
  }

  const targetPath = getResolvedPublishedDocumentPath(
    data.documentId,
    data.latestPublishedVersionId,
    shouldOpenInWord,
  );

  return <Navigate to={targetPath} replace />;
};

export default PublishedDocumentResolverPage;
